var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-select',{attrs:{"options":_vm.unitOptions},on:{"change":function($event){return _vm.updateValue()}},model:{value:(_vm.model.unit),callback:function ($$v) {_vm.$set(_vm.model, "unit", $$v)},expression:"model.unit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }